import { render, staticRenderFns } from "./WorkflowDiagram.vue?vue&type=template&id=0ef9dcb2&scoped=true"
import script from "./WorkflowDiagram.vue?vue&type=script&lang=js"
export * from "./WorkflowDiagram.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDiagram.vue?vue&type=style&index=0&id=0ef9dcb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef9dcb2",
  null
  
)

export default component.exports